import { useUserStore } from "@/store/user";
import { useMainStore } from "@/store/main";
import { MoonIcon } from "@/components/Icons/MoonIcon";
import { SunIcon } from "@/components/Icons/SunIcon";
import { cn } from "@/lib/utils";
import env from "@/env";
import { useExplorerOnlyMode } from "@/hooks/useExplorerOnlyMode";

const SECTIONS_WITH_FORCED_THEME = ["cloud", "ai", "explorer", "worker", "id", "staking"] as const;

export const ThemeToggle = () => {
  const theme = useUserStore((state) => state.theme);
  const updateTheme = useUserStore((state) => state.updateTheme);
  const tool = useMainStore((state) => state.tool);
  const explorerOnlyMode = useExplorerOnlyMode();

  if (!env.THEME_TOGGLE_ENABLED || explorerOnlyMode) return null;
  if (
    env.SECTION_THEME_ENABLED &&
    tool?.value &&
    SECTIONS_WITH_FORCED_THEME.includes(tool.value as (typeof SECTIONS_WITH_FORCED_THEME)[number])
  ) {
    return null;
  }

  return (
    <div
      className="flex items-center gap-1 rounded-full border border-gray-dark-200 bg-background p-0.5 dark:border-gray-dark-1200 dark:bg-gray-dark-600"
      data-testid="ThemeToggle"
    >
      <button
        type="button"
        onClick={() => updateTheme("light")}
        className={cn(
          "flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors",
          theme === "light"
            ? "bg-gray-dark-200 text-foreground shadow-sm dark:bg-gray-dark-1100 dark:text-on-dark"
            : "text-gray-dark-1000 hover:bg-gray-dark-1100 hover:text-on-dark dark:text-gray-dark-1300 dark:hover:bg-gray-dark-1100 dark:hover:text-on-dark"
        )}
        aria-label="Light mode"
        data-testid="ThemeToggle_light"
      >
        <SunIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => updateTheme("dark")}
        className={cn(
          "flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors",
          theme === "dark"
            ? "bg-gray-dark-200 text-foreground shadow-sm dark:bg-gray-dark-1100 dark:text-on-dark"
            : "text-gray-dark-1000 hover:bg-gray-dark-1100 hover:text-on-dark dark:text-gray-dark-1300 dark:hover:bg-gray-dark-1100 dark:hover:text-on-dark"
        )}
        aria-label="Dark mode"
        data-testid="ThemeToggle_dark"
      >
        <MoonIcon className="h-4 w-4" />
      </button>
    </div>
  );
};
